export class RoleSettings {
    public constructor() {
        // Hide all permissions by default.
        $('.perm-group-row').css('display', 'none');

        // Toggle visibility.
        $('.perm-group-header .visible-toggle').click((evt) => {
            const group = $(evt.currentTarget).data('group') as string;
            const visible = $(evt.currentTarget).data('visible') as string;

            this.changeVisibility(evt.currentTarget, group, visible ? 0 : 1);
        });

        $('#perm-show-all').click(() => {
            $('.perm-group-header .visible-toggle').each((i, elmt) => {
                const group = $(elmt).data('group') as string;
                this.changeVisibility(elmt, group, 1);
            });
        });

        $('#perm-hide-all').click(() => {
            $('.perm-group-header .visible-toggle').each((i, elmt) => {
                const group = $(elmt).data('group') as string;
                this.changeVisibility(elmt, group, 0);
            });
        });

        // Update permission category headers
        $('.permission input[type=radio]').click(() => this.updateCategoryTotals());
        this.updateCategoryTotals();

        // Limits
        $('.limit-row input[type="checkbox"]').click((evt) => {
            const name = $(evt.currentTarget).attr('name');

            const row = $(evt.currentTarget).closest('.limit-row');
            const valInput = row.find('input[type="number"]');
            const inftyInput = row.find('input[name^="limitsInfinity"]');

            // "Active" checkbox clicked
            if (name.substr(0, 12) == 'limitsActive') {
                if ($(evt.currentTarget).prop('checked')) {
                    if (inftyInput.prop('checked')) {
                        valInput.attr('disabled', 'disabled');
                    } else {
                        valInput.removeAttr('disabled');
                    }
                    inftyInput.removeAttr('disabled');
                }
                else {
                    valInput.attr('disabled', 'disabled');
                    inftyInput.attr('disabled', 'disabled');
                }
            }

            // "Infinity" checkbox clicked
            else if (name.substr(0, 14) == 'limitsInfinity') {
                if ($(evt.currentTarget).prop('checked')) {
                    valInput.attr('disabled', 'disabled');
                } else {
                    valInput.removeAttr('disabled');
                }
            }
        });
    }

    private changeVisibility(link: HTMLElement, group: string, visibility: number) {
        const icon = $(link).find('i');

        $(`.perm-group-row[data-group=${group}`).css('display', visibility ? '' : 'none');

        $(link).data('visible', visibility);

        if (visibility) {
            icon.removeClass('fa-plus-square');
            icon.addClass('fa-minus-square');
        } else {
            icon.removeClass('fa-minus-square');
            icon.addClass('fa-plus-square');
        }
    }

    private updateCategoryTotals() {
        const groupTotals: Record<string, Record<string, number>> = {};
        $('.permission input[type=radio]:checked').each((i, elmt) => {
            // Find row group
            const group = $(elmt).closest('tr').data('group') as string;
            if (groupTotals[group] == null) {
                groupTotals[group] = {
                    '-1': 0,
                    '0': 0,
                    '1': 0
                };
            }
            groupTotals[group][$(elmt).val() as string]++;
        });

        for (const g in groupTotals) {
            const n: Record<string, number> = groupTotals[g];
            $(`#total-grant-${g}`).html((n['1'] > 0) ? `<strong>${n['1']}</strong>` : '0');
            $(`#total-nochange-${g}`).html(`${n['0']}`);
            $(`#total-revoke-${g}`).html((n['-1'] > 0) ? `<strong>${n['-1']}</strong>` : '0');
        }
    }
}
